<template>
  <div name="stdapplinf-detail-pg2">
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['10'] }}</label>
          <div class="form-control readonly-field-color">{{ data.statappl }} - {{ data.desc_statappl }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['20'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(data.dterec) }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="form-control readonly-field-color">{{ data.numreql }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['40'] }}</label>
          <div class="form-control readonly-field-color">{{ data.desc_codposl }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['50'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codempid }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" style="cursor: auto;">
          <div class="sub-topic">{{ labels['60'] }}</div>
        </div>

        <div class="data-box clearfix">
          <div class="clearfix"></div>
          <div class="row">
            <div class="col-md-4 col-md-offset-2">
              <div class="form-group">
                <label>{{ labels['70'] }}</label>
                <div class="form-control readonly-field-color">{{ data.desc_codposc }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>{{ labels['80'] }}</label>
                <div class="form-control readonly-field-color">{{ data.desc_codappr }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-md-offset-2">
              <div class="form-group">
                <label>{{ labels['90'] }}</label>
                <div class="form-control readonly-field-color">{{ data.desc_codcomp }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>{{ labels['100'] }}</label>
                <div class="form-control readonly-field-color">{{ setDateOutput(data.dteappr) }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-md-offset-2">
              <div class="form-group">
                <label>{{ labels['110'] }}</label>
                <div class="form-control readonly-field-color">{{ data.desc_codrej }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-md-offset-2">
              <div class="form-group">
                <label>{{ labels['120'] }}</label>
                <div class="radio">
                  <label class="radio-inline">
                      <input type="radio" value="Y" :checked="data.flgblkls === 'Y' ? true : false" disabled>
                      {{ labels['130'] }}
                  </label>
                  <label class="radio-inline">
                      <input type="radio" value="N" :checked="data.flgblkls === 'N' ? true : false" disabled>
                      {{ labels['140'] }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 col-md-offset-2">
              <div class="form-group">
                <label>{{ labels['150'] }}</label>
                <textarea class="form-control"
                          :value="data.remark"
                          readonly />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg2',
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg2.vue?0436f7eb